<template>
  <div class="wrapper">
    <Header class="black"></Header>

    <div class="main">
      <div class="container">
        <div class="box">
          <div class="title">《趣编网服务协议》</div>
          <div class="cont">
            <div class="section fw">
              <p>《趣编网服务协议》，<span class="keynote">连同帮助栏及在https://www.qvbian.com及其手机客户端、微信小程序</span>上发布的任何其他政策、指引或网站公告（统称“本协议”）构成<span style="font-weight:bold;">用户（“您”）</span>和<span class="keynote">杭州趣编网络科技有限公司（“趣编网”）</span>之间就您使用网站www.qvbian.com（“网站”）、手机客户端和微信小程序服务达成的合同。 <span class="keynote">通过勾选“同意服务协议”或趣编网提供的其他用户注册渠道进行注册或通过接入、访问、浏览、使用本网站的任何部分或趣编网提供的服务</span>，您同意您已阅读、理解本协议，并同意受本协议约束。<span class="keynote">请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款。限制、免责条款可能以下划线形式提示您注意。您使用趣编网的服务即视为您已阅读并同意上述协议的约束。阅读本协议的过程中，如果您不同意本协议或其中任何条款的约定，您应立即停止注册程序。</span></p>
            </div>

            <div class="section">
              <p>一、 【服务内容】</p>
              <p>1.1 本协议项下的具体服务是指趣编网根据实际情况向用户提供的短视频和/或策划案展示、创作、交易的服务（“服务”）。<span class="keynote">您必须年满18周岁，方可使用服务，若您未满18周岁，请务必在法定监护人陪同下使用。</span></p>
              <p>1.2 有关服务的功能和程序的更多说明请见网站指引或说明，<span class="keynote">趣编网有权自行决定不时修改该等功能和程序，而无需另行通知您。</span></p>
              <p>1.3 您确认并同意，对网站和服务的使用（包括网站和服务的任何买卖功能的实现）都根据本协议条款进行。</p>
              <p>1.4 <span style="font-weight:bold;">作为您使用网站和服务的条件之一，您承诺您不会：（a）冒充或虚报您与任何人士或实体的关联关系；（b）访问、篡改或使用网站和服务或趣编网的计算机系统的任何非公开区域；（c）试图探测、扫描或测试网站、服务或任何相关系统或网络的漏洞，或违反就网站、服务及该等系统和网络使用的任何安全或身份验证措施；（d）试图破译、反编译、反汇编、反向工程或另行调查用于提供网站或服务的任何软件或组件；（e）以任何方式损害或威胁损害其他用户，或干扰或试图干扰任何用户对主机或网络的访问，包括但不限于发送病毒、超载、洪泛、垃圾邮件或邮件炸弹，或其他方式；（f）提供属于第三方的支付信息；（g）以违背网站或服务的设计用途、趣编网的政策和说明、您对任何第三方的义务或任何适用法律的方式滥用网站或服务；（h）从服务进行数据或其他内容的系统性回收，以直接或间接创建或编译单一或多个下载、集合、汇编、数据库、目录或类似程序，不论是手动抑或通过使用机器人（bots）、爬网程序（crawlers）、网页爬虫（spiders）或其他方式；（i）以违背第三方提供网站和服务运行的必要设施和技术的条款和条件的方式利用网站和服务；（j）在使用或访问网站或服务时侵犯趣编网或任何第三方的知识产权，包括但不限于利用服务提供虚拟物品；（k）利用、推广、链接至趣编网自行决定认为具有攻击性或造成对趣编网声誉的损害的材料，或提供该等材料的访问，包括但不限于不合法内容、色情内容及其他视为攻击性或有损趣编网和/或服务的内容。</span></p>
              <p>1.5 <span class="keynote">如您有趣编网自行决定认为不合法、违反本协议的条款，或另行对其他用户、对网站和服务的使用造成不利影响的任何行为或活动，趣编网有权随时终止您的账户或对网站或服务的使用（由趣编网自行决定）。您确认趣编网可以选择，但无义务在终止您对服务或网站的使用前向您发送通知。</span></p>
            </div>

            <div class="section">
              <p>二、 【帐号与密码安全】</p>
              <p>2.1 您在使用趣编网的服务时可能需要注册一个帐号。趣编网特别提醒您应妥善保管您的帐号和密码。当您使用完毕后，应安全退出。<span class="keynote">因您保管不善可能导致遭受盗号或密码失窃，责任由您自行承担。账户因您主动泄露或因您遭受他人诈骗等行为导致的损失及后果，趣编网并不承担责任，您应通过司法、行政等救济途径向侵权行为人主张权利。</span></p>
              <p>2.2 <span class="keynote">您不应将自己的帐号、密码转让或出借予他人使用。</span>如您发现自己的帐号遭他人非法使用，应立即通知趣编网，并有权通知趣编网采取措施暂停该账号的登录和使用。同时，您也应向趣编网提供与被停用账号注册信息相一致的个人有效身份信息。趣编网核实您所提供的个人有效身份信息与所注册的身份信息相一致的，应当及时采取措施暂停该账号的登录和使用。若您没有提供个人有效身份证件或者用户提供的个人有效身份信息与所注册的身份信息不一致的，趣编网有权拒绝上述请求。此外，因计算机病毒、黑客行为、或您的保管疏忽等行为导致帐号、密码遭他人非法使用，趣编网不承担任何责任。</p>
              <p>2.3 <span class="keynote">您注册的帐号自注册起90天内或连续365天，没有使用过该帐号（包括使用该帐号登录网站等），则趣编网有权删除该帐号，包括但不限于注册信息、等级信息、购买记录等一切与该注册帐号相关的信息。</span></p>
            </div>

            <div class="section">
              <p>三、 【用户个人信息保护】</p>
              <p>3.1 保护您的个人信息安全是趣编网的一项基本原则。</p>
              <p>3.2 您在注册帐号或使用服务的过程中，可能需要填写一些必要的信息。您需要填写真实的身份信息，若您填写的信息不完整，则无法使用服务或在使用过程中受到限制。<span class="keynote">您了解并同意，您有义务保持您提供的信息的真实性及有效性。您同意并认可若法律有明确规定要求趣编网必须对部分用户的信息进行核实的情况下，您应当配合提供最新、真实有效的信息。否则趣编网有权依约停止对您提供服务。</span></p>
              <p>3.3 一般情况下，您可随时浏览、修改自己提交的信息，但出于安全性和身份识别（如号码申诉服务）的考虑，您可能无法修改注册时提供的初始注册信息及其他验证信息。</p>
              <p>3.4 趣编网将运用各种安全技术和程序建立完善的管理制度来保护您的个人信息，以免遭受未经授权的访问、使用或披露。</p>
              <p>3.5 未经您的同意，趣编网不会主动向趣编网及其关联方以外的任何公司、组织和个人披露您的个人信息，但法律法规另有规定的除外。</p>
              <p>3.6 您同意并认可在不透露单个用户隐私资料的前提下，趣编网有权对包括您的数据在内的用户数据库进行技术分析并对已进行分析、整理后的用户数据库进行商业上的利用。</p>
              <p>3.7 <span class="keynote">未经您的许可，趣编网不得向任何第三方（不包括趣编网的关联方）公开或共享您注册资料中的姓名、个人有效身份证件号码、联系方式、家庭住址等个人身份信息，但下列情况除外：(a)您授权趣编网披露的；(b)有关法令要求趣编网披露的；(c)司法机关或行政机关基于法定程序要求趣编网提供的；(d)趣编网为了维护自己合法权益而向您提起诉讼或者仲裁时； (e)为维护社会公众的利益。</span></p>
            </div>

            <div class="section">
              <p>四、 【使用服务的方式】</p>
              <p>4.1 您承诺以真实身份注册成为趣编网的用户，并保证所提供的个人身份资料信息真实、完整、有效，依据法律规定和必备条款约定对所提供的信息承担相应的法律责任。您以真实身份注册成为趣编网用户后，需要修改所提供的个人身份资料信息的，趣编网将及时、有效地为您提供该项服务。</p>
              <p>4.2 您对所持账号产生的行为依法享有权利和承担责任<span class="keynote">（包括但不限于在线签署各类协议、发布信息、购买或出售商品或服务以及信息披露）。</span></p>
              <p>4.3 除非您与趣编网另有约定，您同意服务仅为您个人使用。</p>
              <p>4.4 您应当通过趣编网提供或认可的方式使用服务。您依本协议条款所取得的权利不可转让。</p>
              <p>4.5 您不得使用未经趣编网授权的插件、外挂或第三方工具对本协议项下的服务进行干扰、破坏、修改或施加其他影响。</p>
              <p>4.6 您通过服务对程序的使用受制于某些已经包含在规则中的行为准则。这些规则将在趣编网官方网站公开并不定期更新，所有通过服务使用程序的用户必须遵守。您有义务知晓、了解并遵守这些行为规则。趣编网保留权利决定何种行为违反网站精神，并对该等行为采取其认为合适的相应的处理措施（包括但不限于警告、暂时或永久冻结账号、拒绝提供服务等）。趣编网保留随时修改这些行为规则的权利。</p>
              <p>4.7 您有权仅为个人用途使用服务和网站，但您无权未经趣编网的事先书面同意，以任何方式向其他方出售服务、授予在服务中的担保权益、或转让服务的复制品，或向他人出租、出借或许可服务，但本协议其他规定明确允许者除外。</p>
            </div>
            　
            <div class="section">
              <p>五、 【按现状提供服务】</p>
              <p>5.1 您同意趣编网的服务是按照现有技术和条件所能达到的现状提供的。趣编网会尽最大努力向您提供服务，确保服务的连贯性和安全性；<span class="keynote">但趣编网不能随时预见和防范法律、技术以及其他风险，包括但不限于不可抗力、病毒、木马、黑客攻击、系统不稳定、第三方服务瑕疵、政府行为等原因可能导致的服务中断、数据丢失以及其他的损失和风险。</span></p>
              <p>5.2 <span class="keynote">您同意对于趣编网无法预见的第三方风险，导致您权益受损的，趣编网不承担该责任。</span></p>
            </div>

            <div class="section">
              <p>六、 【自备设备】</p>
              <p>6.1 您应当理解，您使用趣编网的服务需自行准备与相关服务有关的终端设备（如电脑、调制解调器等装置），并承担所需的费用（如电话费、上网费等费用）。 </p>
              <p>6.2 您同意，您使用服务时会耗用您的终端设备和带宽等资源。</p>
            </div>

            <div class="section">
              <p>七、 【广告】</p>
              <p>7.1 您理解并同意，趣编网可以在提供服务的过程中自行或由第三方广告商向您发送广告、推广或宣传信息（包括商业与非商业信息），其方式和范围可不经向您特别通知而变更。</p>
              <p>7.2 趣编网依照法律的规定对广告商履行相关义务，您应当自行判断广告信息的真实性并为自己的判断行为负责，除法律明确规定外，您因依该广告信息进行的交易或前述广告商提供的内容而遭受的损失或损害，趣编网不承担责任。</p>
            </div>

            <div class="section">
              <p>八、 【收费服务】</p>
              <p>8.1 趣编网的部分服务是以收费方式提供的，如您使用收费服务，请遵守相关的协议。</p>
              <p>8.2 <span class="keynote">趣编网可能根据实际需要对收费服务的收费标准、方式进行修改和变更，趣编网也可能会对部分免费服务开始收费。前述修改、变更或开始收费前，趣编网将在相应服务页面进行通知或公告。如果您不同意上述修改、变更或付费内容，则应主动停止使用该服务；如果您继续使用该服务但不支付相关费用的，趣编网有权决定终止您对该服务的使用。</span></p>
            </div>

            <div class="section">
              <p>九、 【第三方提供的产品或服务】</p>
              <p>9.1 您在趣编网平台上使用第三方提供的产品或服务时，除遵守本协议约定外，还应遵守第三方的用户协议。趣编网和第三方对可能出现的纠纷在法律规定和约定的范围内各自承担责任。</p>
            </div>

            <div class="section">
              <p>十、 【服务中的软件】</p>
              <p>您在使用服务的过程中可能需要下载软件，对于这些软件，趣编网给予您一项个人的、不可转让及非排他性的许可。您仅可为访问或使用服务的目的而使用这些软件。为了改善用户体验、保证服务的安全性及产品功能的一致性，趣编网可能会对软件进行更新。您应该将相关软件更新到最新版本，否则趣编网并不保证其能正常使用。</p>
            </div>

            <div class="section">
              <p>十一、 【知识产权声明】</p>
              <p>11.1 趣编网在服务中提供的内容（包括但不限于网页、文字、图片、音频、视频、图表等）的知识产权归趣编网所有，您在使用服务中所产生的内容的知识产权归您或相关权利人所有。<span class="keynote">除另有特别声明外，趣编网提供服务时所依托软件的著作权、专利权及其他知识产权均归趣编网所有。趣编网在服务中所使用的趣编logo形象等商业标识，其著作权或商标权归趣编网所有。上述及其他任何服务包含的内容的知识产权均受到法律保护，未经趣编网、您个人或相关权利人书面许可，任何人不得以任何形式进行使用或创造相关衍生作品。</span></p>
              <p>11.2 您在使用付费服务过程中委托趣编网或其他第三方产生的知识产权所有权由各方签订的协议为准。</p>
            </div>

            <div class="section">
              <p>十二、 【用户违法行为】</p>
              <p><span class="keynote">您在使用服务时须遵守法律法规，不得利用服务从事违法违规行为，包括但不限于：</span></p>
              <p><span class="keynote">( 1 ) 发布、传送、传播、储存危害国家安全统一、破坏社会稳定、违反公序良俗、侮辱、诽谤、淫秽、暴力以及任何违反国家法律法规的内容；</span></p>
              <p><span class="keynote">( 2 ) 发布、传送、传播、储存侵害他人知识产权、商业秘密等合法权利的内容；</span></p>
              <p><span class="keynote">( 3 ) 恶意虚构事实、隐瞒真相以误导、欺骗他人；</span></p>
              <p><span class="keynote">( 4 ) 发布、传送、传播广告信息及垃圾信息；</span></p>
              <p><span class="keynote">( 5 ) 其他法律法规禁止的行为。 您应当确保您对在网站上发布的内容享有相应的权利，您不得在网站上发布以下产品或服务：</span></p>
              <p><span class="keynote">1.国家禁止或限制的；</span></p>
              <p><span class="keynote">2.侵犯他人知识产权或者合法权利的；</span></p>
              <p><span class="keynote">3.网站明令禁止的。</span></p>
              <p>如果您违反了本条约定，相关国家机关、机构或相关权利人可能会对您提起诉讼、罚款或采取其他制裁措施，并要求趣编网给予协助。造成损害的，您应依法予以赔偿，趣编网不承担任何责任。<span class="keynote">如果趣编网发现或收到他人举报您发布的信息违反本条约定，趣编网有权进行独立判断并采取技术手段予以删除、屏蔽或断开链接。同时，趣编网有权视您的行为性质，采取包括但不限于暂停或终止服务，限制、冻结或终止账号使用，追究法律责任等措施。 您违反本条约定，导致任何第三方损害的，您应当独立承担责任；趣编网因此遭受损失的（包括但不限于第三方直接向趣编网主张赔偿等情形），您也应当一并赔偿。</span></p>
            </div>

            <div class="section">
              <p>十三、 【遵守当地法律监管】</p>
              <p>您在使用服务过程中应当遵守当地相关的法律法规，并尊重当地的道德和风俗习惯。如果您的行为违反了当地法律法规或道德风俗，您应当为此独立承担责任。 您应避免因使用服务而使趣编网卷入政治和公共事件，否则趣编网有权单方决定暂停或终止对您的服务。</p>
            </div>

            <div class="section">
              <p>十四、 【用户发送、传播的内容与第三方投诉处理】</p>
              <p>您通过服务发送或传播的内容（包括但不限于网页、文字、图片、音频、视频、图表等）均由您自行承担责任。您发送或传播的内容应有合法来源，相关内容为您所有或您已获得权利人的授权。您同意趣编网可为履行本协议或提供服务的目的而使用您发送或传播的内容。<span class="keynote">如果趣编网收到权利人通知，主张您发送或传播的内容侵犯其相关权利的，您同意趣编网有权进行独立判断并采取删除、屏蔽或断开链接等措施。</span></p>
            </div>

            <div class="section">
              <p>十五、 【不可抗力及其他免责事由】</p>
              <p>您理解并同意，在使用服务的过程中，可能会遇到不可抗力等风险因素，使服务发生中断。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行为等。出现上述情况时，趣编网将努力在第一时间与相关单位配合，及时进行修复，但是由此给您造成的损失趣编网在法律允许的范围内免责。 在法律允许的范围内，趣编网对以下情形导致的服务中断或受阻不承担责任：</p>
              <p>( 1 ) 受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏；</p>
              <p>( 2 ) 您或趣编网的电脑软件、系统、硬件和通信线路出现故障；</p>
              <p>( 3 ) 您操作不当；</p>
              <p>( 4 ) 您通过非趣编网授权的方式使用服务；</p>
              <p><span class="keynote">您理解并同意，在使用服务的过程中，可能会遇到网络信息或其他用户行为带来的风险，趣编网不对任何信息的真实性、适用性、合法性承担责任，也不对因第三方的侵权行为给您造成的损害负责。</span>这些风险包括但不限于：</p>
              <p>1)来自他人匿名或冒名的含有威胁、诽谤、令人反感或非法内容的信息；</p>
              <p>2)因使用本协议项下的服务，遭受他人误导、欺骗或其他导致或可能导致的任何心理、生理上的伤害以及经济上的损失；</p>
              <p>3)其他因网络信息或用户行为引起的风险。</p>
              <p>趣编网仅向您提供平台服务，您了解平台上的信息系用户自行发布，且可能存在风险与瑕疵，趣编网将依法建立相关检查制度尽可能保障您在平台上的合法权益。鉴于平台具备海量信息以及用户发布的服务无明显特征进行辨别，趣编网无法进行逐一审查，对交易的真实性、合法性，您应谨慎判断，因此造成的您的损失，您可按相关法律法规规定，向侵权人主张您的合法权益，对此趣编网不承担责任。 
您理解并同意，服务并非为某些特定目的而设计，包括但不限于核设施、军事用途、医疗设施、交通通讯等重要领域。如果因为软件或服务的原因导致上述操作失败而带来的人员伤亡、财产损失和环境破坏等，趣编网不承担法律责任。趣编网依据本协议约定获得处理违法违规内容的权利，该权利不构成趣编网的义务或承诺，趣编网不能保证及时发现违法行为或进行相应处理。 在任何情况下，您不应轻信借款、索要密码或其他涉及财产的网络信息。涉及财产操作的，请一定先核实对方身份，并请经常留意趣编网有关防范诈骗犯罪的提示。</p>
            </div>

            <div class="section">
              <p>十六、 【协议的生效与变更】</p>
              <p>您使用趣编网的服务即视为您已阅读本协议并接受本协议的约束。<span class="keynote">趣编网有权在必要时修改本协议条款，且将会发布通告告知您，您应及时查看修改后的协议，本协议条款变更后，如果您继续使用趣编网提供的软件或服务，即视为您已接受修改后的协议。如果您不接受修改后的协议，应当停止使用趣编网提供的软件或服务。</span></p>
            </div>

            <div class="section">
              <p>十七、 【服务的变更、中断或终止】</p>
              <p>鉴于网络服务的特殊性，您同意趣编网有权随时变更、中断或终止部分或全部的网络服务（包括收费网络服务）。<span class="keynote">如变更、中断或终止的网络服务，趣编网无需通知您，也无需对您或任何第三方承担任何责任，但趣编网将尽可能事先进行通告。</span>您理解并同意，趣编网需要定期或不定期地对提供网络服务的平台（如互联网网站、移动网络等）或相关的设备进行检修或者维护。趣编网服务的各个新版本，趣编网可以自行决定是否保留为趣编网服务增加附加特点和功能，或者提供程序编程之修补、更新和升级的权利。趣编网无需向您发出通知即可自行决定修改、停止或暂停您对任何版本趣编网服务的使用，和/或禁用您已经使用或安装的趣编网服务，以便对相关技术进行检修、改良和/或升级，或者出于其他合理原因；对于由发行和/或不发行趣编网服务的新版本而导致的直接或间接损害，趣编网将不承担任何赔偿责任。</p>
              <p><span class="keynote">如发生下列任何一种情形，趣编网有权不经通知而中断或终止向您提供的服务：</span></p>
              <p><span class="keynote">( 1 ) 根据法律规定您应提交真实信息，而您提供的个人资料不真实、或与注册时信息不一致又未能提供合理证明；</span></p>
              <p><span class="keynote">( 2 ) 您违反相关法律法规或本协议的约定；</span></p>
              <p><span class="keynote">( 3 ) 按照法律规定或主管部门的要求；</span></p>
              <p><span class="keynote">( 4 ) 出于安全的原因或其他必要的情形。</span></p>
            </div>

            <div class="section">
              <p>十八、 【管辖与法律适用】</p>
              <p><span class="keynote">本协议签订地为中华人民共和国浙江省杭州市滨江区。</span>本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。 若您和趣编网之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，<span class="keynote">您同意将纠纷或争议提交本协议签订地有管辖权的人民法院管辖。</span>本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。 本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。</p>
            </div>

            <div class="section">
              <p>十九、 【其他】</p>
              <p>如果您对本协议或服务有任何意见或建议，可与趣编网客户服务部门联系，我们会给予您必要的帮助。</p>
            </div>

            <div class="section">
              <p>杭州趣编网络科技有限公司</p>
            </div>

          </div>
        </div>
      </div>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
  import '@/assets/js/common'
  import Header from  '@/components/Header'
  import Footer from  '@/components/Footer'

  export default {
    components:{
      Header,
      Footer,
    },
  }
</script>

<style scoped>
  .main{
    padding: 30px 0 219px;
  }
  .box{
    padding: 30px;
    background: #ffffff;
  }
  .title{
    margin-bottom: 30px;
    text-align: center;
    font-size: 20px;
    color: #424753;
    font-weight: 600;
  }
  .section{
    margin-bottom: 20px;
  }
  .section p{
    font-size: 12px;
    line-height: 24px;
  }
  .section p:nth-child(1){
    font-weight: 600;
  }
  .section.fw p:nth-child(1){
    font-weight: normal;
  }
  .red{
    color: red;
  }
  .keynote{
    font-weight:bold; 
    text-decoration:underline;
    padding-left: 2px;
    padding-right: 2px; 
  }
</style>



// WEBPACK FOOTER //
// App.vue?5084d60c